export enum PowerUnit {
  AMPERE = 'A',
  WATT = 'W',
  KILOWATT = 'kW',
  KILOVOLT_AMPERE = 'kVA'
}
